import { Box } from '@mui/material'
import _ from 'lodash'
import PropTypes from 'prop-types'
import Picto from './Picto'

const PictoGroup = (props) => {
  const { disabledLetters, text, onPictoClick, ...rest } = props
  return (
    <Box {...rest} sx={{ display: 'flex' }}>
      {_.toArray(text).map((letter, i) => (
        <Picto
          key={i}
          letter={letter}
          onClick={
            !disabledLetters || disabledLetters.indexOf(letter) < 0
              ? onPictoClick?.bind(null, letter)
              : undefined
          }
        />
      ))}
    </Box>
  )
}

PictoGroup.propTypes = {
  disabledLetters: PropTypes.string,
  text: PropTypes.string.isRequired,
  onPictoClick: PropTypes.func,
}

export default PictoGroup
